import { createWeb3Modal, defaultWagmiConfig } from "@web3modal/wagmi/react";
import PropTypes from "prop-types";
import { WagmiConfig, configureChains, createConfig, mainnet } from "wagmi";
import { arbitrum, goerli } from "wagmi/chains";
import { infuraProvider } from "wagmi/providers/infura";
import { publicProvider } from "wagmi/providers/public";

import {
    INFURA_API_KEY,
    WALLET_CONNECT_API_KEY,
} from "../utils/config";
import { KIITESTNET_CHAIN_ID } from "./contracts";

// KiiTestnet chain config
export const kiiTestnet = {
  id: KIITESTNET_CHAIN_ID,
  name: 'KiiTestnet',
  network: 'kiitestnet',
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://json-rpc.uno.sentry.testnet.v3.kiivalidator.com/'],
    },
    public: {
      http: ['https://json-rpc.uno.sentry.testnet.v3.kiivalidator.com/'],
    },
  },
  blockExplorers: {
    default: { name: 'Kii Explorer', url: 'https://explorer.kiichain.io/' },
  },
  testnet: true,
};

const { chains, publicClient } = configureChains(
    [
        mainnet,
        goerli,
        arbitrum,
        kiiTestnet // Added KiiTestnet to supported chains
    ],
    [
        infuraProvider(
            {
                apiKey: INFURA_API_KEY
            }
        ),
        publicProvider(),
    ],
    {
        // rank: true,
        multicallVersion: 2,
        refresh: "everyBlock"
    }
);


const projectId = WALLET_CONNECT_API_KEY;

const config = defaultWagmiConfig({
    chains,
    projectId
});

const wagmiConfig = createConfig({
    ...config,
    autoConnect: true,
    connectors: config.connectors,
    publicClient,
});

createWeb3Modal({ wagmiConfig, projectId, chains });

const WagmiProvider = ({ children }) => (
    <WagmiConfig config={wagmiConfig} >{children}</WagmiConfig>
);

WagmiProvider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export default WagmiProvider;
